import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CancelSubscription } from 'src/app/cancel-subscription';

@Component({
    selector: 'app-cancel-subscription-alert-modal',
    templateUrl: './cancel-subscription-alert-modal.component.html',
    styleUrls: ['./cancel-subscription-alert-modal.component.css'],
    imports: [ReactiveFormsModule]
})
export class CancelSubscriptionAlertModalComponent implements OnInit {
  @Output() okay: EventEmitter<CancelSubscription> = new EventEmitter<CancelSubscription>();
  calcelSubscriptionForm: UntypedFormGroup;

  constructor(
    public modal: NgbActiveModal) {

    }
  ngOnInit(): void {
    this.calcelSubscriptionForm = new UntypedFormGroup({
      changeRemarks: new UntypedFormControl()
    });
  }

  cancelSubscription() {
    this.okay.emit(this.calcelSubscriptionForm.value);
    this.modal.close();
  }

  closeModal() {
    this.modal.close();
  }
}
